module.exports = __webpack_public_path__ + "static/media/map_animation.2b5a796a.gif";